import initA11yMenu from './components/a11y';
import initCookies from './components/cookies';
import initMobileMenu from './components/mobile-menu';
import initDesktopMenu from './components/desktop-menu';
import initFooterAccordion from './components/footer-accordion';
import initMarcasSlider from './pages/sobre/swiper-marcasSlider';
import initAccordion from './components/accordion';
import initScrollPage from './components/scrollPage-banners';

import initShare from './components/share';

import initNovidadesRelacionadas from './pages/novidades-relacionadas';

import initHothome from './pages/home/hothome';
import initCategoriesHome from './pages/home/categorias';
import initProductsTabs from './pages/home/tabs';
import initHighlights from './pages/home/destaques';

import initLoadMoreCategories from './pages/categorias/grid';
import initProdutosRelacionadosCategorias from './pages/categorias/produtos-relacionados';

import initGallery from './pages/produto/gallery';
import initAncoraProdutos from './pages/produto/ancora';
import initEspecificacoes from './pages/produto/especificacoes';
import initDestaques from './pages/produto/destaques';
import initVideo from './pages/produto/video';
import initProdutosRelacionados from './pages/produto/produtos-relacionados';

import initLoadMoreProducts from './pages/marca/load-more';
import initVideoPlayMarca from './pages/marca/video';

import initSearchProducts from './pages/subcategoria/busca';
import initResultsCounterProducts from './pages/subcategoria/contador';
import initGridToggleProducts from './pages/subcategoria/grid';
import initFiltersProducts from './pages/subcategoria/filtros';
import initPaginationProducts from './pages/subcategoria/paginacao';

import initPolicyNavigation from './pages/politica/politica';

import initFiltersDownloads from './pages/downloads/filtros';
import initGridToggleDownloads from './pages/downloads/grid';
import initSearchDownloads from './pages/downloads/busca';
import initSortDownloads from './pages/downloads/ordenacao';
import initPaginationDownloads from './pages/downloads/paginacao';

import initCompareStorage from './pages/comparador/comparador-storage';
import initCompareTrigger from './pages/comparador/comparador-trigger';
import initCompareWidget from './pages/comparador/comparador-widget';
import initComparePage from './pages/comparador/comparador-page';
import initRelatedProductsSliderComparador from './pages/comparador/produtos-relacionados';

import initResultadosProdutosSlider from './pages/busca/produtos';
import initResultadosArtigosSlider from './pages/busca/artigos';

import initMapaAssistencia from './pages/assistencia-tecnica/mapa';
import initAssistenciaLista from './pages/assistencia-tecnica/filtro';

import initCarrosselNovidadesDestaqueBlog from './pages/novidades/swiper-destaque'
import initConfiraMaisBlog from './pages/novidades/swiper-single-confira';
import initBlogCopiarLink from './pages/novidades/single-copiar-link';
import initBuscaPosts from './pages/novidades/busca-post';
import initOrdenacaoBlog from './pages/novidades/ordenacao-blog';
import initFiltroCategoriasBlog from './pages/novidades/filtro-categoria-blog';

import initFaq from './pages/faq/faq';

import initFileUpdate from './pages/contato/forms';

import initCarrosselBlock from './blocks/carrossel';

document.addEventListener('DOMContentLoaded', () => {
  initA11yMenu();
  initCookies();
  initMobileMenu();
  initDesktopMenu();
  initFooterAccordion();
  initFaq();
  initConfiraMaisBlog();
  initBuscaPosts();
  initFiltroCategoriasBlog();
  initOrdenacaoBlog();
  initBlogCopiarLink();
  initFileUpdate();
  initMarcasSlider();
  initCarrosselBlock();
  initShare();
  initAccordion();
  initScrollPage();

  initNovidadesRelacionadas();

  initHothome();
  initCategoriesHome();
  initProductsTabs();
  initHighlights();

  initLoadMoreCategories();
  initProdutosRelacionadosCategorias();

  initGallery();
  initAncoraProdutos();
  initEspecificacoes();
  initDestaques();
  initVideo();
  initProdutosRelacionados();

  initLoadMoreProducts();
  initVideoPlayMarca();

  initSearchProducts();
  initResultsCounterProducts();
  initFiltersProducts();
  initGridToggleProducts();
  initPaginationProducts();

  initPolicyNavigation();

  initFiltersDownloads();
  initGridToggleDownloads();
  initSearchDownloads();
  initSortDownloads();
  initPaginationDownloads();

  initCompareStorage();
  initCompareTrigger();
  initCompareWidget();
  initComparePage();
  initRelatedProductsSliderComparador();

  initResultadosProdutosSlider();
  initResultadosArtigosSlider();

  initAssistenciaLista();
  initMapaAssistencia();

  initCarrosselNovidadesDestaqueBlog();

  console.log('Ferramentas a postos.');
});
